import { Box, Drawer as MuiDrawer } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const DRAWER_WIDTH = 576

export const Drawer = styled(MuiDrawer)<{ integrationtype: 'add' | 'edit' }>`
  .MuiPaper-root {
    background: ${theme.colors.surfaceContainerBackground};
    box-shadow: ${theme.attributes.boxShadow.selectFieldPaper};
    width: ${DRAWER_WIDTH}px;
    overflow-x: hidden;

    ::-webkit-scrollbar {
      width: 4px;
      background: transparent;
    }

    ::-webkit-scrollbar-track {
      box-shadow: none;
      background: ${theme.colors.borderLow};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.cta};
      border-radius: ${theme.attributes.borderRadius.quaternary};
    }

    .wrapper-inner {
      height: 100%;
      padding: ${theme.spacing.xLarge}px ${theme.spacing.xSmall}px ${theme.spacing.xLarge}px ${theme.spacing.xLarge}px;
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing.large}px;

      .inner-scrollable-section {
        flex-grow: 1;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.large}px;
        padding-right: ${theme.spacing.large}px;

        ::-webkit-scrollbar {
          width: 4px;
          background: transparent;
        }

        ::-webkit-scrollbar-track {
          box-shadow: none;
          background: transparent;
        }

        ::-webkit-scrollbar-thumb {
          background-color: ${theme.colors.borderMedium};
          border-radius: ${theme.attributes.borderRadius.quaternary};
        }
      }

      .header-container {
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin-bottom: ${({ integrationtype }) => (integrationtype === 'add' ? `${theme.spacing.xSmall}px` : '')};

          .close-icon {
            width: 40px;
            height: 40px;

            &:hover {
              background: rgba(202, 196, 208, 0.12);
            }

            svg {
              path {
                fill: ${theme.colors.menuItemText};
              }
            }
          }

          .title {
            color: ${theme.colors.menuItemText};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.xxxxLarge};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.bold};
            line-height: 42px;
            word-break: break-all;
          }
        }

        .sub-header-title {
          color: ${theme.colors.dropdownLabel};

          html[data-theme='light'] & {
            color: ${theme.colors.textCaption};
          }

          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 130%;
          letter-spacing: 0.1px;
        }
      }

      .categories-wrapper {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: ${theme.spacing.xSmall}px;
      }

      .description-wrapper {
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xSmall}px;

        .description-title {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 20px;
          letter-spacing: 0.1px;
        }

        .description-text {
          color: ${theme.colors.devicesSecondaryText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: 20px;
          letter-spacing: 0.25px;
          word-break: break-word;
        }
      }
    }
  }
`

export const CpisListWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  width: 100%;
  padding: ${theme.spacing.small}px;
  align-items: center;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};

  .analyzer-block {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xSmall}px;
    width: 100%;

    .title {
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 16px;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 24px;
      letter-spacing: 0.5px;
      color: #fff;

      html[data-theme='light'] & {
        color: ${theme.colors.menuItemText};
      }
    }
  }

  .cpis-list-header {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.md}px;
    width: 100%;

    .cpis-list-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 16px;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }

    .cpis-list-description {
      color: ${theme.colors.devicesSecondaryText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.25px;
    }
  }

  .cpis-list-inner-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;
    width: 100%;

    .cpis-list-item {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.md}px;
      width: 100%;
      height: 24px;

      .cpis-list-chip {
        display: flex;
        width: 72px;
        height: 24px;
        padding: 2px ${theme.spacing.xSmall}px;
        justify-content: center;
        align-items: center;
        border-radius: 18px;
        background: ${theme.colors.devicesRowHoverBg};
        color: ${theme.colors.devicesSecondaryText};
        text-align: center;
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.medium};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 16px;
        letter-spacing: 0.5px;
      }

      .cpis-list-title {
        color: ${theme.colors.menuItemText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: normal;
        flex-grow: 1;
      }

      &:hover {
        cursor: pointer;

        .cpis-list-chip {
          background: ${theme.colors.cta};
          color: ${theme.colors.surfaceContainerBackground};
        }

        .cpis-list-title {
          color: ${theme.colors.cta};
        }

        svg {
          path {
            fill: ${theme.colors.cta};
          }
        }
      }
    }
  }
`

export const InstancesWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  width: 100%;
  padding: ${theme.spacing.small}px;
  align-items: center;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};

  .instances-inner {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;
    width: 100%;

    .instances-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 16px;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }
  }
`

export const IntegrationInstanceItem = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;

  .instances-instance-name {
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  .instance-blocks-list {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;

    .instance-block-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .instance-block-icon-wrapper {
        display: flex;
        width: 48px;
        height: 48px;
        padding: 10px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        aspect-ratio: 1/1;
        border-radius: ${theme.attributes.borderRadius.tertiary};
        background: ${theme.colors.devicesRowHoverBg};

        html[data-theme='light'] & {
          background: ${theme.colors.cardFillTertiary};

          svg path {
            stroke: ${theme.colors.selectChevron};
          }
        }
      }

      .instance-block-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .instance-block-content-title {
          color: ${theme.colors.devicesSecondaryText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: 22px;
        }

        .instance-block-content-text {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 20px;
        }
      }
    }
  }
`

export const ActionsWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  gap: ${theme.spacing.xSmall}px;
  padding-right: 32px;

  .MuiButton-root {
    border-radius: ${theme.attributes.borderRadius.tertiary};
    color: ${theme.colors.surfaceContainerBackground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 22px;
    width: 100%;
    height: 48px;
    box-shadow: none !important;

    svg {
      path {
        fill: none;
      }
    }

    &.view-instances-button {
      border: 1px solid ${theme.colors.dropdownBorder};
      color: ${theme.colors.devicesSecondaryText};

      &.delete-button {
        border: 1px solid ${theme.colors.dropdownBorder};
        color: ${theme.colors.devicesSecondaryText};

        html[data-theme='light'] &:not(:hover):not(:focus):not(:active) {
          color: ${theme.colors.btnSecondaryText};

          svg path {
            stroke: ${theme.colors.btnSecondaryText};
          }
        }
      }

      &:hover {
        background: ${theme.colors.borderMedium};
        color: ${theme.colors.menuItemText};
      }

      &:focus,
      &:active {
        background: transparent;
        color: ${theme.colors.cta};
        border-color: ${theme.colors.cta};
      }

      &.role-disabled {
        background: transparent;
        color: ${theme.colors.btnSecondaryDisabledText};
        border-color: ${theme.colors.borderMedium};
        opacity: 1;
        cursor: default;

        svg {
          path {
            stroke: ${theme.colors.btnSecondaryDisabledText};
          }
        }
      }
    }

    &.add-instance-button {
      background: ${theme.colors.cta};
      color: ${theme.colors.surfaceContainerBackground};

      &:hover {
        background: #c477c1;
        color: ${theme.colors.primaryDark};
      }

      &:focus,
      &:active {
        background: ${theme.colors.btnTertiaryBg};
        color: ${theme.colors.cta};
        border-color: ${theme.colors.btnTertiaryBg};
      }

      &.role-disabled {
        background: ${theme.colors.tooltipBg};
        color: ${theme.colors.surfaceContainerBackground};
        opacity: 1;
        border: 1px solid transparent;
        cursor: default;

        svg {
          path {
            stroke: ${theme.colors.surfaceContainerBackground};
          }
        }
      }
    }
  }
`

export const MetaDataWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  width: 100%;
  padding: ${theme.spacing.small}px;
  align-items: center;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};

  .metadata-inner {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;
    width: 100%;
    overflow-y: auto;

    .metadata-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 16px;
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 24px;
      letter-spacing: 0.1px;
    }
  }
`

export const MetaDataItem = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;

  .metadata-blocks-list {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;

    .metadata-block-item {
      display: flex;
      align-items: center;
      gap: 10px;

      .metadata-block-icon-wrapper {
        display: flex;
        width: 48px;
        height: 48px;
        padding: 10px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        aspect-ratio: 1/1;
        border-radius: ${theme.attributes.borderRadius.tertiary};
        background: ${theme.colors.devicesRowHoverBg};

        html[data-theme='light'] & {
          background: ${theme.colors.cardFillTertiary};

          svg path {
            stroke: ${theme.colors.selectChevron};
          }
        }
      }

      .metadata-block-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .metadata-block-content-title {
          color: ${theme.colors.devicesSecondaryText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: 22px;
        }

        .metadata-block-content-text {
          color: ${theme.colors.menuItemText};
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: 20px;
        }
      }
    }
  }
`

export const ErrorWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  width: 100%;
  padding: ${theme.spacing.small}px;
  align-items: center;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid ${theme.colors.borderMedium};

  .header {
    display: flex;
    align-items: center;
    gap: ${theme.spacing.small}px;

    .icon-wrapper {
      display: flex;
      min-width: 48px;
      width: 48px;
      height: 48px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      aspect-ratio: 1/1;
      border-radius: ${theme.attributes.borderRadius.tertiary};
      background: ${theme.colors.devicesRowHoverBg};
    }

    .header-title {
      color: ${theme.colors.menuItemText};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
    }
  }

  .content {
    ul {
      margin-top: 0;
      margin-bottom: 0;
      padding-left: 24px;

      li {
        color: ${theme.colors.devicesSecondaryText};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 20px;
      }
    }
  }

  .footer {
    display: flex;
    padding: ${theme.spacing.small}px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border-radius: ${theme.attributes.borderRadius.tertiary};
    background: rgba(231, 76, 60, 0.1);

    .footer-text {
      color: #e74c3c;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
    }
  }
`
